import { CustomerService } from "@/services/api/customer.service";
import { basePagesMutations } from "@/store/base-pages";

const state = {
  items: [],
  meta: {
    total: 0,
  },
};

export default {
  namespaced: true,

  state: { ...state },

  mutations: {
    ...basePagesMutations,
  },

  actions: {
    removeItem({ commit, rootState }, drug) {
      return CustomerService.removeDrug(rootState.customer.id, drug.id, rootState.auth.id).then(response => {
        if (response.success) {
          commit("REMOVE_ITEM", drug);
          commit("DECREASE_META_TOTAL");
        }

        return response;
      });
    },
  },
};
